import React, { FC, useMemo } from 'react'
import { useReportCardCancellationModalContext } from '../ReportCardCancellationModalContext'
import { useTranslation } from 'next-i18next'
import { Button, Text } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../utils/responsive'
import { useReportCardCancellation } from '../hooks'
import { IconPosition, PaymentMethodRow } from '../../PaymentMethodRow'
import { maskCreditCardNumber } from '../../../utils/card'

const I18N_NAMESPACE = ['account']

export const Confirm: FC = () => {
  const { textSize } = useConsumerSizes()
  const { t } = useTranslation(I18N_NAMESPACE)
  const { selectedCardIds, creditCards } = useReportCardCancellationModalContext()
  const { confirm } = useReportCardCancellation()

  const body = useMemo(() => {
    if (selectedCardIds.length === creditCards.length) {
      return t('account:tab:payment-methods:reportCardCancellationModal:body:confirm:allCard')
    }

    return t('account:tab:payment-methods:reportCardCancellationModal:body:confirm:partialCard')
  }, [selectedCardIds.length, creditCards.length, t])
  const selectedCard = useMemo(() => {
    return creditCards.filter((card) => selectedCardIds.includes(card.id))
  }, [creditCards, selectedCardIds])

  return (
    <>
      <div className='mb-4'>
        {selectedCard.map((card, index) => {
          return (
            <div key={card.id} className={index === 0 ? '' : 'mt-4'}>
              <PaymentMethodRow
                number={maskCreditCardNumber(card.truncatedNumber ?? card.maskedPan)}
                cardType={card.cardBrand}
                expiryDate={card.expiryDate}
                iconPosition={IconPosition.Left}
              />
            </div>
          )
        })}
      </div>
      <Text size={textSize}>{body}</Text>
      <div className='mt-4'>
        <Button padding='Fluid' onClick={confirm}>
          {t('account:tab:payment-methods:reportCardCancellationModal:cta:confirm')}
        </Button>
      </div>
    </>
  )
}
